<template>
    <button v-if="icon || count"
        class="el-btn-icon"
        :type="type"
        :disabled="disabled"
        :title="$options.filters.athT(title)"
        @click="$emit('click', $event)"
        ref="btn">
        <slot name="before"></slot>
        <i v-if="icon" :class="[icon ? `lnr-${icon}` : '']"></i>
        <span v-if="count || count===0">&nbsp;{{ count }}</span>
        <slot name="after"></slot>
    </button>
    <button v-else-if="html"
        class="el-btn-icon"
        :type="type"
        :disabled="disabled"
        :title="$options.filters.athT(title)"
        @click="$emit('click', $event)"
        v-html="html"
        ref="btn"></button>
</template>

<script>
export default {
    name: 'mead-button-icon',
    props: {
        /**
         * The native HTML `type` attribute for the underlying `<button>` element.
         */
        type        : {type: String, default: () => 'button'},
        /**
         * Name of an icon (rendered via `lnr-{icon}`) shown inside the button.
         * When set (or when `count` is provided), the button renders using its
         * default icon+count markup rather than the raw `html` markup.
         */
        icon        : {type: [String, Boolean], default: () => false},
        /**
         * Raw HTML rendered inside the button (via `v-html`) when neither `icon`
         * nor `count` is set, for cases where custom markup is needed.
         */
        html        : {type: [String, Boolean], default: () => false},
        /**
         * Disables the button, preventing clicks and applying the disabled styling.
         */
        disabled    : {type: Boolean, default: () => false},
        /**
         * Tooltip text for the button, run through the `athT` filter and applied
         * as the native `title` attribute.
         */
        title       : {type: [String, Boolean], default: () => false},
        /**
         * Optional numeric count rendered next to the icon. Accepts `false` to
         * omit it; `0` is still shown.
         */
        count       : {type: [Number, Boolean], default: () => false},
        /**
         * When true, the button automatically receives focus once mounted.
         */
        uiAutoFocus : {type: Boolean, default: () => false},
    },
    mounted () {
        //  UIAutoFocus
        if (this.$refs.btn && this.uiAutoFocus) this.$refs.btn.focus();
    },
};
</script>
